import { useCallback, useState } from 'react';

import { cx } from '@libs/classnames';
import { ContentEditableText } from '@ui/components/ContentEditableText/ContentEditableText';

import styles from '@features/tournament/ui/components/TournamentParticipantsEdit/TournamentParticipantsEdit.module.css';

type Props = {
  className?: string;
  value: number;
  onChange?: (newValue: number) => void;
};
export function PositionInput({ className, value, onChange }: Props) {
  const [isActive, setIsActive] = useState(false);

  const handleChange = useCallback(
    (newValue: string) => {
      if (isNaN(Number(newValue))) return;
      setIsActive(false);
      onChange?.(Number(newValue));
    },
    [onChange],
  );

  const handleClick = useCallback(() => {
    setIsActive(true);
  }, [setIsActive]);

  if (!onChange) {
    return <span>{value}</span>;
  }

  if (!isActive) {
    return (
      <span className={cx(styles.order, styles.isClickable)} onClick={handleClick}>
        {value}
      </span>
    );
  }

  return (
    <ContentEditableText
      className={cx(styles.order, className)}
      inputMode="numeric"
      initialValue={value.toString()}
      onCommit={handleChange}
      onBlur={handleChange}
      autoFocus
      maxLength={2}
    />
  );
}
